import React, { useState } from 'react'
import { IoMdClose } from "react-icons/io";
import productCategory from '../helper/productCategory';
import { FaCloudUploadAlt } from "react-icons/fa";
import uploadImage from '../helper/uploadImage';
import DisplayImage from './DisplayImage';
import { MdDelete } from "react-icons/md";
import SummaryApi from '../common';
import {toast} from 'react-toastify'



const UploadProduct = ({
  onClose,
  fetchData 

}) => {
  const[data, setData] = useState({
    productName : "",
    brandName : "",
    category : "",
    productImage: [],
    description: "",
    price : "",
    sellingPrice : ""



  })
  const [openFullScreenImage, setOpenFullScreenImage] = useState(false )

  const [fullScreenImage, setFullScreenImage] = useState("")


  const handleOnChange = (e)=>{
      const { name, value} = e.target

      setData((preve)=>{
        return{
          ...preve,
          [name]  : value
        }
      })
  }

  const handleUploadProduct = async (e) => {
    const file = e.target.files[0]
    const uploadImageCloudinary = await uploadImage(file)
    setData((preve)=>{
      return {
        ...preve, 
        productImage : [...preve.productImage,uploadImageCloudinary.url ]
      }
    })
    
  }

  const handleDeleteProductImage = async(index) =>{
    

    const newProductImage = [...data.productImage]
    newProductImage.splice(index, 1)

    setData((preve)=>{
      return {
        ...preve, 
        productImage : [...newProductImage]
      }
    })

  }
{/**upload product */}
  const handleSubmit = async(e) =>{
    e.preventDefault()
   

    const response  = await fetch(SummaryApi.uploadProduct.url,{
      method: SummaryApi.uploadProduct.method,
      credentials: 'include',
      headers :{
        "content-type" : "application/json"
      },
      body : JSON.stringify(data)
    })
    const responseData = await response.json()

    if(responseData.success){
      toast.success(responseData?.message)
      onClose()
      fetchData()
    }

    if(responseData.error){
      toast.error(responseData?.message)
    }


  }
  return (
    <div className='fixed w-full h-full bg-slate-200 bg-opacity-35 top-0 left-0 right-0 bottom-0 flex justify-center items-center'>
      <div className='bg-[#c8d7ee] p-4 rounded w-full max-w-2xl h-full max-h-[80%] overflow-hidden' >
          <div className='flex justify-between items-center pb-3'>
            <h2 className='font-bold text-lg'>Upload Product</h2>
            <div className='w-fit ml-auto text-2xl hover:scale-110 cursor-pointer ' onClick={onClose}>
               <IoMdClose />
            </div>
          </div>
          <form className='grid p-4 gap-2 overflow-y-scroll h-full pb-5' onSubmit={handleSubmit}>
            <label htmlFor='productName'>Product Name :</label>
            <input 
            type='text'
            id='productName' 
            placeholder='enter the product name ' 
            name='productName'
            value={data.productName} 
            onChange={handleOnChange}
            className='p-2 bg-[#e9eff9] border rounded'
            required
            ></input>

            <label htmlFor='brandName' className='mt-3'>Brand Name :</label>
            <input 
            type='text'
            id='brandName' 
            placeholder='enter the brand name ' 
            name='brandName'
            value={data.brandName} 
            onChange={handleOnChange}
            className='p-2 bg-[#e9eff9] border rounded'
            required

            ></input>

            <label htmlFor='category' className='mt-3'>Category :</label>
            <select required value={data.category} name='category' onChange={handleOnChange} className='p-2 bg-[#e9eff9] border rounded' >
                <option value={""} >Select Category</option>
              {
                productCategory.map((el, index) =>{
                  return(
                    <option value={el.value} key={el.value+index}>{el.value}</option>
                  )
                })
              }
            </select>

            <label htmlFor='productImage' className='mt-3'>Product Image :</label>
            <label htmlFor='uploadImageInput'>
            <div className='p-2 bg-[#e9eff9] border rounded h-32 w-full flex justify-center items-center cursor-pointer'>
            
                <div className='text-[#091f3f]  flex justify-center items-center flex-col'>
                    <span className='text-3xl'><FaCloudUploadAlt /></span>
                    <p className='text-sm'>Upload Product Image </p>
                    <input type='file' id='uploadImageInput' className='hidden' onChange={handleUploadProduct}></input>
                </div>
           

            </div>
            </label>
            <div>
                {
                  data?.productImage[0] ? (
                    <div className='flex items-center gap-2 '>
                      {
                        data.productImage.map((el, index) =>{
                          return(
                           <div className='relative group'>
                              <img src={el} 
                                alt={el}
                                width={80} 
                                height={80}
                                className='bg-[#e9eff9] border cursor-pointer' 
                                onClick={() =>{
                                  setOpenFullScreenImage(true)
                                  setFullScreenImage(el)
                                  }}/>
                                  {/***hidden deletion is not working -------*/}
                                  <div className='absolute  bottom-0 right-0 p-1 text-white bg-[#091f3f] rounded-full hidden group-hover:flex cursor-pointer z-10 outline outline-2 outline-blue-400' onClick={()=>handleDeleteProductImage(index)} >
                                          <MdDelete/>  
                                  </div>
                           </div>
                           
                            )
                          })
                      }
                    </div>

                  ) :(
                    <p className='text-black text-xs'>*Please upload product image</p>
                  )
                }
             
            </div>

            <label htmlFor='price' className='mt-3'>Price :</label>
            <input 
                type='number' 
                id='price' 
                placeholder='enter price' 
                value={data.price} 
                name='price'
                onChange={handleOnChange}
                className='p-2 bg-[#e9eff9] border rounded'
                required
              />

            <label htmlFor='sellingPrice' className='mt-3'>Selling Price :</label>
            <input 
                type='number' 
                id='sellingPrice' 
                placeholder='enter selling price' 
                value={data.sellingPrice} 
                name='sellingPrice'
                onChange={handleOnChange}
                className='p-2 bg-[#e9eff9] border rounded'
                required
              />

              <label htmlFor='description' className='mt-3'>Description :</label>
              <textarea 
                className='h-28 bg-[#e9eff9] border resize-none p-1' 
                placeholder='enter product description' 
                rows={3} 
                onChange={handleOnChange} 
                name='description'
                value={data.description}
              >
              </textarea>

            <button className='px-3 py-2 bg-[#eeb934] hover:bg-[#f0c65c]'>Upload Product</button>


            
          </form>
      </div>
      
      {/***display image full screen  */}
      {
        openFullScreenImage && (
          <DisplayImage onClose={() =>{setOpenFullScreenImage(false)}} imgUrl={fullScreenImage}/>
          )
      }
    </div>
  )
}

export default UploadProduct